// extracted by mini-css-extract-plugin
export var container = "ExtraOptionsCheck-module--container--1RB1P";
export var buttonContainer = "ExtraOptionsCheck-module--buttonContainer--3_iDq";
export var optionsContainer = "ExtraOptionsCheck-module--optionsContainer--t3xMK";
export var moreInfo = "ExtraOptionsCheck-module--moreInfo--24Ef_";
export var show = "ExtraOptionsCheck-module--show--2-q6f";
export var sizeTable = "ExtraOptionsCheck-module--sizeTable--3-kyu";
export var lookbookLinkContainer = "ExtraOptionsCheck-module--lookbookLinkContainer--dTy6-";